export default {
    IMAGE: 1,
    VIDEO: 2,
    AUDIO: 3,
    DOCUMENT: 10,
    ARCHIVE: 5,
    UNSUPPORTED: 20
};
